import DrownRoute from './src/DrownRoute.vue';
DrownRoute.install = (Vue)=>{
    Vue.components(DrownRoute.name,DrownRoute)
}
export default DrownRoute;
